(function () {
  var mobileQuery = window.matchMedia('(max-width: 768px)');

  function init(root) {
    root = root || document;
    var cols = root.querySelectorAll('.hrc-footer__col[data-footer-accordion]');
    if (!cols.length) return;

    cols.forEach(function (col) {
      var trigger = col.querySelector('.hrc-footer__col-title');
      if (!trigger) return;

      if (mobileQuery.matches) {
        if (!trigger.dataset.bound) {
          trigger.addEventListener('click', function () {
            var isOpen = col.classList.toggle('is-open');
            trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          });
          trigger.dataset.bound = 'true';
        }
      } else {
        col.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  init();

  var nwslSuccess = document.querySelector('.hrc-footer__nwsl-success');
  if (nwslSuccess) {
    var nwslSection = document.getElementById('hrc-footer-nwsl');
    if (nwslSection) {
      nwslSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  mobileQuery.addEventListener('change', function () {
    init();
  });

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
